export default __webpack_public_path__ + "static/media/bra-arte-1.18ff2f0a.webp";